import { render, staticRenderFns } from "./LoyaltyProgram.vue?vue&type=template&id=6c30571a&scoped=true&"
import script from "./LoyaltyProgram.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyProgram.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyProgram.vue?vue&type=style&index=0&id=6c30571a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30571a",
  null
  
)

export default component.exports